import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getJrSummary } from '../services/jrOverview.js';

export default function JrPripominka() {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    getJrSummary()
      .then((d) => setRows(d.maklers))
      .catch((e) => setError(e.message || 'Data se nepodařilo načíst.'));
  }, []);

  const on = (rows || []).filter((m) => m.reminder_enabled).length;

  return (
    <section className="dashboard">
      <div className="dashboard__header">
        <div>
          <h1 className="dashboard__title">Denní připomínka na zápis</h1>
          <p className="dashboard__lead">
            Jedna připomínka denně, jen tomu, kdo ještě nezapsal. Makléři ji zapneš při uvítání –
            během 15 minut zaškolení, spolu s Drillem na ploše telefonu.
          </p>
        </div>
      </div>
      {error && <p className="dashboard__error" role="alert">{error}</p>}
      <div className="card">
        <h2 className="card__title">Nastavení <small>jen ke čtení</small></h2>
        <dl className="kpi__test">
          <div><dt>Kanál</dt><dd>Push upozornění přímo z Drillu, ne přes WhatsApp. Otevře rovnou formulář zápisu.</dd></div>
          <div><dt>Čas odeslání</dt><dd>18:00 – mění se v Parametrech, JR a JCH společně.</dd></div>
          <div><dt>Dny</dt><dd>Po–Pá, pracovní dny. Svátky Drill vynechá sám. V tichém období 21. 12.–1. 1. připomínka neběží.</dd></div>
          <div><dt>Kdo ji dostává</dt><dd>Všichni s povinným zápisem – od přípravy po úroveň 3. Na úrovni 4 je zápis dobrovolný.</dd></div>
        </dl>
        <Link className="button button--secondary" to="/dashboard/parametry">Změnit čas v Parametrech</Link>
      </div>
      <div className="card">
        <h2 className="card__title">Jak to vidí makléř</h2>
        <p className="card__text">Připomínka zapnutá: {on} z {(rows || []).length}</p>
        <ul className="jr-list">
          {(rows || []).map((m) => (
            <li key={m.id}>
              <Link to={`/dashboard/database/${m.id}`}>{m.name}</Link> · {m.level} ·{' '}
              {m.reminder_enabled ? 'zapnuto' : 'vypnuto'}
            </li>
          ))}
        </ul>
        <p className="card__hint">Zapíná se při uvítání. Pravidla pro vypnutí model zatím neurčuje.</p>
      </div>
    </section>
  );
}
